import React, { useState, useRef, useEffect } from 'react';
import { AnalyticsPeriod } from 'types/interfaces/admin/analytics';

interface Props {
  value: AnalyticsPeriod;
  onChange: (period: AnalyticsPeriod) => void;
}

const TIME_RANGE_OPTIONS = [
  { value: 7 as AnalyticsPeriod, label: '1 Week' },
  { value: 30 as AnalyticsPeriod, label: '1 Month' },
];

const TimeRangeDropdown: React.FC<Props> = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedLabel = TIME_RANGE_OPTIONS.find(opt => opt.value === value)?.label || '1 Week';

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (period: AnalyticsPeriod) => {
    onChange(period);
    setIsOpen(false);
  };

  return (
    <div className="time-range-dropdown" ref={dropdownRef}>
      <div
        className="time-range-dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{selectedLabel}</span>
        <svg
          aria-hidden="true"
          focusable="false"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          width="10"
          height="10"
          className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
        >
          <path
            fill="#878787"
            d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
          />
        </svg>
      </div>

      {isOpen && (
        <div className="time-range-dropdown-menu">
          {TIME_RANGE_OPTIONS.map((option) => (
            <div
              key={option.value}
              className={`time-range-dropdown-item ${value === option.value ? 'selected' : ''}`}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TimeRangeDropdown;
